import { render, staticRenderFns } from "./_reportFileSnapshotsTable.vue?vue&type=template&id=8f27522a"
import script from "./_reportFileSnapshotsTable.vue?vue&type=script&lang=js"
export * from "./_reportFileSnapshotsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports